module.exports = __webpack_public_path__ + "static/media/hyundai.4be804e4.png";